import React from "react";

import { Tooltip, Typography } from "clearsense-ui/components";
import { LinkText } from "components/Common/TableStyle";
import { getTimeAndDate } from "utils/date";

import { formatBytes } from "../SourceDatabases/utils";

const COLUMN_DATA = [
  {
    dataIndex: "fileName",
    key: "fileName",
    title: "File Name",
    width: 350,
    render: (_, record) => (
      <LinkText text={record.fileName} link={`/consumption/datasets`} />
    ),
    sorter: (a, b) => a.fileName.localeCompare(b.fileName),
  },
  {
    dataIndex: "creationDate",
    key: "creationDate",
    title: "Creation Date",
    width: 200,
    render: (_, { creationDate }) => {
      if (!creationDate) return "Not available";
      const { date, time } = getTimeAndDate(creationDate);

      return (
        <Tooltip content={creationDate.fromNow()} position="bottom">
          <Typography>{`${date} ${time}`}</Typography>
        </Tooltip>
      );
    },
    sorter: (a, b) => (a.creationDate.isAfter(b.creationDate) ? 1 : -1),
  },
  {
    dataIndex: "lastModified",
    key: "lastModified",
    title: "Last Modified",
    width: 200,
    render: (_, { lastModified }) => {
      if (!lastModified) return "Not available";
      const { date, time } = getTimeAndDate(lastModified);

      return (
        <Tooltip content={lastModified.fromNow()} position="bottom">
          <Typography>{`${date} ${time}`}</Typography>
        </Tooltip>
      );
    },
    sorter: (a, b) => (a.lastModified.isAfter(b.lastModified) ? 1 : -1),
  },
  {
    dataIndex: "size",
    key: "size",
    title: "Size",
    align: "center",
    width: 100,
    render: (_, { size }) => formatBytes(size),
    sorter: (a, b) => a.size - b.size,
  },
];

export default COLUMN_DATA;
